import { LoadingState, type LoadingStateProps } from "@salestrak/ui";
import { LOADING_PHRASES } from "./loading-phrases";

export type PageLoadingProps = Pick<LoadingStateProps, "delayed">;

/**
 * THE full-pane wait for every route gate inside the shell: the library
 * `LoadingState` over the app's phrase pool. `delayed` is for gates that
 * usually resolve at once from cache — a redirect or a permission decision —
 * so the common path paints nothing.
 */
export function PageLoading({ delayed = false }: PageLoadingProps) {
  return <LoadingState caption={LOADING_PHRASES} delayed={delayed} />;
}
